import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import theme from './theme';

/**
 * Emotion style classes
 */
const primaryButton = css`
  background-color: ${theme.color.highlight} !important;

  &:hover,
  &:active {
    filter: brightness(0.9);
  }

  &:active {
    box-shadow: 0 0 5px ${theme.color.shadow};
  }
`;

/**
 * Components
 */
const PrimaryButton = ({ text, iconName, handleClick }) => (
  <button
    className={`${primaryButton} button is-primary`}
    onClick={handleClick}
  >
    <span className="icon">
      <i className={`fa fa-${iconName}`} />
    </span>
    <span>{text}</span>
  </button>
);

PrimaryButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  /** FontAwesome icon name (ex. 'plus-square') */
  iconName: PropTypes.string,
  text: PropTypes.string,
};

PrimaryButton.defaultProps = {
  iconName: 'plus-square',
  text: 'more',
};

export default PrimaryButton;
